import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { CookiesProvider } from 'react-cookie'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { customTheme } from 'styles/materialTheme/theme'
import { config } from 'config'
import { AuthContainer, AuthContainerState, UtilsContainer, UtilsContainerState } from 'containers'
import { AppLoader } from 'app/AppLoader'
import { ErrorBoundary } from 'app/ErrorBoundary'

const { GOOGLE_CLIENT_ID } = config!

type AppProps = {
  children?: React.ReactNode
  authContainerState?: AuthContainerState
  utilsContainerState?: UtilsContainerState
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: 0,
      retry: false,
    },
  },
})

const App: React.FC<AppProps> = ({ children, ...props }) => {
  const { authContainerState, utilsContainerState } = props

  return (
    <MuiThemeProvider theme={customTheme}>
      <QueryClientProvider client={queryClient}>
        <CookiesProvider>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AuthContainer.Provider initialState={authContainerState}>
              <UtilsContainer.Provider initialState={utilsContainerState}>
                <ErrorBoundary>{children ?? <AppLoader />}</ErrorBoundary>
              </UtilsContainer.Provider>
            </AuthContainer.Provider>
          </GoogleOAuthProvider>
        </CookiesProvider>
      </QueryClientProvider>
    </MuiThemeProvider>
  )
}

export default App
